import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'modalTitle'
	| 'modalSubtitle'
	| 'createAgentButton'
	| 'closeButton'
	| 'browseAgentsButton'
	| 'loadingAgents'
	| 'searchPlaceholder'
	| 'favouritesSectionTitle';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		modalTitle: {
			id: 'rovo-chat.browse-agents.modal-title',
			defaultMessage: 'Browse agents',
			description: 'Title of the modal to browse agents',
		},
		modalSubtitle: {
			id: 'rovo-chat.browse-agents.modal-subtitle',
			defaultMessage: 'Discover agents that help move work forward.',
			description: 'Label that is shown under the modal header in browse agents modal',
		},
		createAgentButton: {
			id: 'ai-mate.browse-agents-view.create-agent-button',
			defaultMessage: 'Create Agent',
			description: 'Label shown on the create agent button in the browse agents view',
		},
		closeButton: {
			id: 'ai-mate.browse-agents-view.close-button',
			defaultMessage: 'Close agents view',
			description: 'Label shown on the close button in the browse agents view',
		},
		browseAgentsButton: {
			id: 'rovo-chat.browse-agents.browse-agents-button',
			defaultMessage: 'Browse all',
			description: 'Label shown on the browse agents button in the browse agents view',
		},
		loadingAgents: {
			id: 'ai-mate.browse-agents-view.loading-agents',
			defaultMessage: 'Loading agents...',
			description: 'Label shown on the loading agents spinner in the browse agents view',
		},
		searchPlaceholder: {
			id: 'rovo-chat.browse-agents.content.search-placeholder',
			defaultMessage: 'Search agents',
			description: 'Placeholder for the browse agents content search input',
		},
		favouritesSectionTitle: {
			id: 'ai-mate.browse-agents-modal-sidebar.favourites-section-title',
			defaultMessage: 'Favorites',
			description: 'Title of the section for favorites agents in the browse agents modal sidebar',
		},
	});

export default message;
